import { render, staticRenderFns } from "./EditarSkeleton.vue?vue&type=template&id=a20a8f16"
import script from "./EditarSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./EditarSkeleton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports